
<template>
  <section>
    <div :class="[listClass]">
      <slot
        name="errors"
        v-bind="{ items , filteredItems }"
      />
      <slot
        name="filter"
        v-bind="{ filters, updateFilter, loadItems, items, filteredItems }"
      />
      <slot name="banner" />
      <slot
        name="pagination"
        v-bind="{ pagination, defaultLimit, allLoaded }"
      />
      <div
        :id="panelId"
        ref="listWrapper"
        :role="singlePanel ? null : 'tabpanel'"
        :style="[
          { height: calculatedHeight }
        ]"
        class="list-wrapper"
        data-component="hotel-list-wrapper"
      >
        <slot v-if="!isMounted" />
        <slot
          name="rendered-list"
          v-bind="{ items, filters }"
        />
        <template v-for="(item) in items">
          <slot
            name="card-template"
            v-bind="{ item, key: JSON.stringify({ item, filters }) }"
          />
        </template>
        <template>
          <slot name="uncontroled-slot" :filtered-elements="items">

          </slot>
        </template>
        <slot
          v-if="items.length === 0"
          name="no-items"
        />
      </div>
      <slot
        name="pagination"
        v-bind="{ pagination, defaultLimit, allLoaded }"
      />
    </div>
  </section>
</template>

<script>
  import ListMixin from '@mixins/list-mixin'

  export default {
    name: 'SimpleList',
    mixins: [ListMixin],
    props: {
      query: {
        type: String,
        default: ''
      },
      undefinedValue: {
        type: String,
        default: null
      },
      singlePanel: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      panelId() {
        const filterValue = this.filters[this.query]

        if (typeof filterValue === 'string') {
          return filterValue
        }

        // If this.query contains dot notation (e.g., "$and.0.category"),
        // it indicates that the value is located within a nested
        // structure in the filters object (e.g., "this.filters.$and[0].category").
        const keys = this.query.split('.')
        const result = keys.reduce((obj, key) => obj?.[key] ?? this.undefinedValue, this.filters)

        return typeof result === 'string' ? result : this.undefinedValue
      }
    }
  }
</script>
